const routes = [
    {
        path: '/lammies',
        component: () => import('@/pages/lammie/LammieHome.vue'),
        meta: { breadCrumb: 'Lammie Requests', entity: 'lammie' },
        children: [
            {
                path: '',
                name: 'lammie',
                component: () => import('@/pages/lammie/LammieList.vue'),
                props: true,
            },
            {
                path: 'filter/:eventId?/:teamId?',
                name: 'filterLammie',
                component: () => import('@/pages/lammie/LammieList.vue'),
                props: true,
                meta: { breadCrumb: 'Filter' },
            },
            {
                path: 'new',
                name: 'newLammie',
                component: () => import('@/pages/lammie/Editor.vue'),
                meta: { breadCrumb: 'New' },
            },
            {
                path: ':id/edit',
                name: 'editLammie',
                component: () => import('@/pages/lammie/Editor.vue'),
                props: true,
                meta: { breadCrumb: 'Edit' },
            },
            {
                path: ':id/read/:tabName?',
                name: 'readLammie',
                component: () => import('@/pages/lammie/LammieRequestReader.vue'),
                props: true,
                meta: { breadCrumb: 'Reading' },
            },
            {
                path: 'archive',
                name: 'lammieArchive',
                component: () => import('@/pages/lammie/LammieArchive.vue'),
                props: true,
            },
        ],
    },
]

export default routes
